import update from 'immutability-helper';
import { RESOURCES } from '../constants';

const defResourceState = {
  isLoading: false,
  isSaving: false,
  isCompleted: false,
  responseData: null,
  data: [],
  params: {},
  total: 0,
  currentPage: 1,
};

// Because a task resource has a summary
const defTaskResourceState = {
  ...defResourceState,
  summary: {
    statuses: {
      started: 0,
      done: 0,
      failed: 0,
      success: 0,
      queued: 0,
    },
    lastUpdate: {},
    isLoaded: false,
  },
};

// IMPORTANT - Every resource must be defined on initialState
export const initialState = {
  isLoading: false,
  clients: defResourceState,
  settings: defResourceState,
  accounts: defResourceState,
  generatePreview: defTaskResourceState,
  resendNewsletter: defTaskResourceState,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESOURCES.FETCH.REQUEST:
    case RESOURCES.REFETCH.REQUEST:
      return update(state, {
        [action.resource]: {
          isLoading: { $set: true },
        },
      });
    case RESOURCES.SAVE.REQUEST:
      return update(state, {
        [action.resource]: {
          isSaving: { $set: true },
          isCompleted: { $set: false },
        },
      });
    case RESOURCES.FETCH.SUCCESS:
    case RESOURCES.REFETCH.SUCCESS:
      return update(state, {
        [action.resource]: {
          isLoading: { $set: false },
          total: { $set: action.payload.total },
          isCompleted: { $set: true },
          currentPage: { $set: action.payload.current_page },
          params: { $set: action.payload.params || {} },
          data: {
            $set: action.payload.data,
          },
        },
      });
    case RESOURCES.FETCH.FAILURE:
      return update(state, {
        [action.resource]: {
          isSaving: { $set: false },
          isCompleted: { $set: true },
          isLoading: { $set: false },
          data: [],
        },
      });
    case RESOURCES.SAVE.SUCCESS:
      return update(state, {
        [action.resource]: {
          isSaving: { $set: false },
          isCompleted: { $set: true },
          responseData: { $set: action.responseData },
        },
      });
    case RESOURCES.SAVE.FAILURE:
      return update(state, {
        [action.resource]: {
          isSaving: { $set: false },
          isCompleted: { $set: true },
        },
      });
    case RESOURCES.ADD_DATA:
      return update(state, {
        [action.resource]: {
          data: { $splice: [[0, 0, action.task]] },
        },
      });
    case RESOURCES.UPDATE_DATA:
      return update(state, {
        [action.resource]: {
          data: {
            $apply: b => b.map((item) => {
              if (item.id === action.task.id) {
                return action.task;
              }
              return item;
            }),
          },
        },
      });
    case RESOURCES.REMOVE_DATA:
      return update(state, {
        [action.resource]: {
          data: arr => arr.filter(item => action.id !== item.id),
        },
      });
    case RESOURCES.REMOVE.REQUEST:
    case RESOURCES.REMOVE_ALL.REQUEST:
      return update(state, {
        [action.resource]: {
          isLoading: { $set: true },
        },
      });
    case RESOURCES.REMOVE.SUCCESS:
      return update(state, {
        [action.resource]: {
          data: arr => arr.filter(item => !action.ids.includes(item.id)),
          total: { $set: 0 },
          isLoading: { $set: false },
        },
      });
    case RESOURCES.REMOVE_ALL.SUCCESS:
      return update(state, {
        [action.resource]: {
          data: { $set: [] },
          total: { $set: 0 },
          isLoading: { $set: false },
        },
      });
    case RESOURCES.TASKS_SUMMARY.SUCCESS:
      return update(state, {
        [action.resource]: {
          summary: {
            $set: {
              ...action.payload,
              isLoaded: true,
            },
          },
        },
      });
    case RESOURCES.TASKS_SUMMARY.RESET:
    case RESOURCES.TASKS_SUMMARY.FAILURE:
      return update(state, {
        [action.resource]: {
          summary: {
            statuses: {
              started: { $set: 0 },
              done: { $set: 0 },
              failed: { $set: 0 },
              success: { $set: 0 },
              queued: { $set: 0 },
            },
            lastUpdate: { $set: {} },
            isLoaded: { $set: true },
          },
        },
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/resources.reducer.js